if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        this.removeAttribute('data-loading');

        if (preventFocus) this.openedBy = null;
        super.hide();
        
      }

      show(opener) {


        const sourceEquities = this.getSourceEquities(opener);

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.modalContent.innerHTML = '';
        this.setAttribute('data-loading', 'true');
        super.show(opener);

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            if (!productElement) throw new Error('Quick add product-info was not found.');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.syncProductEquities(this.modalContent, sourceEquities);
            this.initializeProductPreview(this.modalContent);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.removeAttribute('data-loading');
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      getSourceEquities(opener) {
        const sourceProduct = opener?.closest?.('product-info');
        const sourceEquities = sourceProduct?.querySelector?.('.product-gallery-equities');
        if (!sourceEquities) return null;

        const icons = Array.from(sourceEquities.querySelectorAll('.item')).map((item) => {
          const img = item.querySelector('img');
          if (!img) return null;

          return {
            src: img.getAttribute('src') || '',
            srcset: img.getAttribute('srcset') || '',
            sizes: img.getAttribute('sizes') || '',
            alt: img.getAttribute('alt') || '',
            width: img.getAttribute('width') || '',
            height: img.getAttribute('height') || '',
            loading: img.getAttribute('loading') || '',
            fetchpriority: img.getAttribute('fetchpriority') || '',
          };
        });

        if (!icons.some(Boolean)) return null;

        return {
          icons,
          background: sourceEquities.style.getPropertyValue('--equities-background'),
          color: sourceEquities.style.getPropertyValue('--equities-color'),
          markup: sourceEquities.innerHTML,
        };
      }

      syncProductEquities(root, sourceEquities) {
        if (!root || !sourceEquities) return;

        const targetEquities = root.querySelector('.product-gallery-equities') || this.createProductEquities(root, sourceEquities);
        if (!targetEquities) return;

        if (sourceEquities.background) targetEquities.style.setProperty('--equities-background', sourceEquities.background);
        if (sourceEquities.color) targetEquities.style.setProperty('--equities-color', sourceEquities.color);

        const targetItems = Array.from(targetEquities.querySelectorAll('.item'));
        sourceEquities.icons.forEach((icon, index) => {
          if (!icon || !targetItems[index]) return;

          let targetIcon = targetItems[index].querySelector('img');
          if (!targetIcon) {
            targetIcon = document.createElement('img');
            targetItems[index].prepend(targetIcon);
          }

          this.setEquitiesIconAttributes(targetIcon, icon);
        });
      }

      createProductEquities(root, sourceEquities) {
        const gallery = root.querySelector('media-gallery');
        if (!gallery) return null;

        const targetEquities = document.createElement('div');
        targetEquities.className = 'equities product-gallery-equities quick-add-hidden';
        targetEquities.innerHTML = sourceEquities.markup;
        gallery.appendChild(targetEquities);

        return targetEquities;
      }

      setEquitiesIconAttributes(targetIcon, sourceIcon) {
        ['src', 'srcset', 'sizes', 'alt', 'width', 'height', 'loading', 'fetchpriority'].forEach((attribute) => {
          if (sourceIcon[attribute]) {
            targetIcon.setAttribute(attribute, sourceIcon[attribute]);
          } else {
            targetIcon.removeAttribute(attribute);
          }
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      initializeProductPreview(root) {
        this.initializeDescriptionCards(root);
        this.initializeMediaGalleries(root);
        this.initializePurchaseControls(root);
      }

      initializeDescriptionCards(root) {
        root.querySelectorAll('[data-product-description-card]').forEach((card) => {
          if (card.dataset.descriptionReady === 'true') return;

          const tabs = card.querySelector('[data-product-description-tabs]');
          const panels = card.querySelector('[data-product-description-panels]');
          const toggleButton = card.querySelector('[data-product-description-toggle]') || card.querySelector('#toggle-btn.toggle_btn');
          if (!panels || !toggleButton) return;

          const expandLabel = toggleButton.dataset.expandLabel || 'Learn More';
          const collapseLabel = toggleButton.dataset.collapseLabel || 'View Less';
          const buttonText = toggleButton.querySelector('span');

          const setDescriptionExpanded = (expanded) => {
            card.classList.toggle('is-expanded', expanded);
            toggleButton.classList.toggle('art', expanded);
            card.querySelectorAll('.product__description').forEach((content) => {
              content.classList.toggle('art', expanded);
            });
            if (buttonText) buttonText.textContent = expanded ? collapseLabel : expandLabel;
          };

          if (tabs) {
            const tabButtons = tabs.querySelectorAll('[data-description-tab]');
            card.style.setProperty('--description-tab-count', Math.max(tabButtons.length, 1));

            tabs.addEventListener('click', (event) => {
              const tab = event.target.closest('[data-description-tab]');
              if (!tab) return;

              const activeIndex = tab.dataset.descriptionTab;
              tabButtons.forEach((item) => {
                const isActive = item === tab;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
              });
              panels.querySelectorAll('[data-description-panel]').forEach((panel) => {
                panel.classList.toggle('is-active', panel.dataset.descriptionPanel === activeIndex);
              });
              setDescriptionExpanded(false);
            });
          }

          toggleButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();
              setDescriptionExpanded(!card.classList.contains('is-expanded'));
            },
            true
          );

          card.addEventListener('click', (event) => {
            if (!event.target.closest('.product__description')) return;
            setDescriptionExpanded(true);
          });

          card.dataset.descriptionReady = 'true';
        });
      }

      initializeMediaGalleries(root) {
        const galleries = root.querySelectorAll('media-gallery');
        let delegatedToMediaGallery = false;

        galleries.forEach((gallery) => {
          const initializeGallery = () => {
            gallery.initializeProductGalleryControls?.({ preserveScroll: true });
          };

          if (typeof gallery.initializeProductGalleryControls === 'function') {
            initializeGallery();
            delegatedToMediaGallery = true;
            return;
          }

          if (window.customElements?.whenDefined) {
            window.customElements.whenDefined('media-gallery').then(initializeGallery);
            delegatedToMediaGallery = true;
          }
        });

        if (delegatedToMediaGallery) return;

        root.querySelectorAll('media-gallery').forEach((gallery) => {
          if (gallery.dataset.quickAddGalleryReady === 'true') return;

          const viewer = gallery.querySelector('slider-component.slider-mobile-top');
          const mediaList = gallery.querySelector('[id^="Slider-Gallery"]');
          const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
          if (!viewer || !mediaList || !thumbnails) return;

          const prevButtons = [
            thumbnails.querySelector('.slider-button--prev'),
            viewer.querySelector(':scope > .button_left'),
          ].filter(Boolean);
          const nextButtons = [
            thumbnails.querySelector('.slider-button--next'),
            viewer.querySelector(':scope > .button_right'),
          ].filter(Boolean);

          const normalizeThumbnailItems = () => {
            const firstItem = Array.from(thumbnails.querySelectorAll('.thumbnail-list__item[data-target]')).find(
              (item) => window.getComputedStyle(item).display !== 'none' && item.querySelector('.thumbnail')
            );
            if (!firstItem) return;

            firstItem.classList.remove('thumbnail-list_item--variant');
            firstItem.style.pointerEvents = '';

            const firstButton = firstItem.querySelector('.thumbnail');
            if (!firstButton) return;

            firstButton.disabled = false;
            firstButton.removeAttribute('disabled');
            firstButton.removeAttribute('aria-disabled');
            firstButton.removeAttribute('tabindex');
            firstButton.style.pointerEvents = '';
          };

          const getItems = () =>
            Array.from(thumbnails.querySelectorAll('.thumbnail-list__item[data-target]')).filter((item) => {
              const style = window.getComputedStyle(item);
              return style.display !== 'none' && !item.classList.contains('thumbnail-list_item--variant');
            });

          const setActiveThumbnail = (mediaId) => {
            thumbnails.querySelectorAll('.thumbnail-list__item[data-target]').forEach((item) => {
              const isActive = item.dataset.target === mediaId;
              item.classList.toggle('is-active', isActive);
              const button = item.querySelector('.thumbnail');
              if (!button) return;
              if (isActive) {
                button.setAttribute('aria-current', 'true');
                const list = item.closest('.thumbnail-list');
                if (list) {
                  list.scrollTo({
                    left: Math.max(0, item.offsetLeft - (list.clientWidth - item.clientWidth) / 2),
                    behavior: 'smooth',
                  });
                }
              } else {
                button.removeAttribute('aria-current');
              }
            });
          };

          const getActiveIndex = (items) => {
            const activeThumb = thumbnails.querySelector('.thumbnail[aria-current]');
            const activeItem = activeThumb?.closest('.thumbnail-list__item[data-target]');
            const activeMedia = mediaList.querySelector('.product__media-item.is-active[data-media-id]');
            const activeMediaId = activeItem?.dataset.target || activeMedia?.dataset.mediaId;
            const index = items.findIndex((item) => item.dataset.target === activeMediaId);
            return index >= 0 ? index : 0;
          };

          const updateButtons = () => {
            const items = getItems();
            const activeIndex = getActiveIndex(items);
            prevButtons.forEach((button) => button.toggleAttribute('disabled', activeIndex <= 0));
            nextButtons.forEach((button) => button.toggleAttribute('disabled', activeIndex >= items.length - 1));
          };

          const switchTo = (index) => {
            const items = getItems();
            const targetItem = items[index];
            if (!targetItem) return;

            const mediaId = targetItem.dataset.target;
            const activeMedia = mediaList.querySelector(`[data-media-id="${mediaId}"]`);
            if (!activeMedia) return;

            const productScroller = gallery.closest('.product--medium');
            const previousScrollTop = productScroller ? productScroller.scrollTop : 0;

            mediaList.querySelectorAll('[data-media-id]').forEach((item) => {
              item.classList.toggle('is-active', item.dataset.mediaId === mediaId);
            });
            setActiveThumbnail(mediaId);
            mediaList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
            if (typeof gallery.playActiveMedia === 'function') gallery.playActiveMedia(activeMedia);
            updateButtons();

            if (productScroller) {
              productScroller.scrollTop = previousScrollTop;
              window.requestAnimationFrame(() => {
                productScroller.scrollTop = previousScrollTop;
              });
              window.setTimeout(() => {
                productScroller.scrollTop = previousScrollTop;
              }, 250);
            }
          };

          const switchByOffset = (offset) => {
            const items = getItems();
            const nextIndex = Math.max(0, Math.min(items.length - 1, getActiveIndex(items) + offset));
            switchTo(nextIndex);
          };

          prevButtons.forEach((button) => {
            button.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                switchByOffset(-1);
                button.blur();
              },
              true
            );
          });

          nextButtons.forEach((button) => {
            button.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                switchByOffset(1);
                button.blur();
              },
              true
            );
          });

          thumbnails.querySelectorAll('.thumbnail').forEach((button) => {
            button.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                const item = button.closest('.thumbnail-list__item[data-target]');
                const items = getItems();
                const index = items.findIndex((candidate) => candidate === item);
                if (index >= 0) switchTo(index);
                button.blur();
              },
              true
            );
          });

          normalizeThumbnailItems();
          const initialItem =
            thumbnails.querySelector('.thumbnail[aria-current]')?.closest('.thumbnail-list__item[data-target]') ||
            getItems()[0];
          if (initialItem) setActiveThumbnail(initialItem.dataset.target);
          updateButtons();
          gallery.dataset.quickAddGalleryReady = 'true';
        });
      }

      initializePurchaseControls(root) {
        if (root.quickAddSyncPurchaseControls) {
          root.quickAddSyncPurchaseControls();
          return;
        }

        let isSyncing = false;
        let syncFrame = null;
        const selectors = {
          originQuantity: '.product-form__quantity .hw-origin-quantity-input',
          bottomQuantity: '.bottom_cart .hw-bottom-quantity-input',
          originVariant:
            '.product-form__quantity .price-per-item__container > div .product-form form .product-variant-id',
          bottomVariant: '.bottom_cart .center .right > div .product-form form .product-variant-id',
          originSubmit:
            '.product-form__quantity .price-per-item__container > div .product-form .product-form__submit',
          bottomSubmit: '.bottom_cart .center .right > div .product-form .product-form__submit',
          originPrice: '.product__info-container > .price_flex, .product__info-wrapper .price_flex',
          bottomPrice: '.bottom_cart .tap_price',
        };

        const copyButtonState = (sourceButton, targetButton) => {
          if (!sourceButton || !targetButton) return;

          targetButton.toggleAttribute('disabled', sourceButton.hasAttribute('disabled'));

          const sourceText = sourceButton.querySelector('span');
          const targetText = targetButton.querySelector('span');
          if (sourceText && targetText) targetText.textContent = sourceText.textContent;
        };

        const getQuantityInputs = () =>
          [root.querySelector(selectors.originQuantity), root.querySelector(selectors.bottomQuantity)].filter(Boolean);

        const syncQuantity = (sourceInput = root.querySelector(selectors.originQuantity)) => {
          if (isSyncing || !sourceInput) return;

          isSyncing = true;
          const value = sourceInput.value || sourceInput.getAttribute('value') || '1';
          getQuantityInputs().forEach((input) => {
            if (input !== sourceInput && input.value !== value) input.value = value;
          });
          isSyncing = false;
          syncPrice();
        };

        const syncVariant = () => {
          const originVariant = root.querySelector(selectors.originVariant);
          if (!originVariant) return;

          root.querySelectorAll(selectors.bottomVariant).forEach((bottomVariant) => {
            bottomVariant.value = originVariant.value;
            bottomVariant.toggleAttribute('disabled', originVariant.hasAttribute('disabled'));
          });
        };

        const getQuantity = () => {
          const input = root.querySelector(selectors.bottomQuantity) || root.querySelector(selectors.originQuantity);
          const quantity = Number.parseInt(input?.value || input?.getAttribute('value') || '1', 10);
          return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
        };

        const getSelectedVariant = () => {
          const selectedVariantScript = root.querySelector('variant-selects [data-selected-variant]');
          if (!selectedVariantScript?.textContent) return null;

          try {
            return JSON.parse(selectedVariantScript.textContent);
          } catch (error) {
            return null;
          }
        };

        const formatPriceAmount = (centsValue, templateText = '') => {
          const currency = window.Shopify?.currency?.active;

          if (currency && window.Intl) {
            try {
              return new Intl.NumberFormat(document.documentElement.lang || undefined, {
                style: 'currency',
                currency,
              })
                .format(centsValue / 100)
                .replace(/\bUSD\b/g, '')
                .trim();
            } catch (error) {
              // Fall back to the theme's visible price shape below.
            }
          }

          const amount = centsValue / 100;
          const amountText = centsValue % 100 === 0 && !/[.,]\d{2}\b/.test(templateText)
            ? String(Math.round(amount))
            : amount.toFixed(2);

          if (templateText.includes('$')) return `$${amountText}`;
          return templateText ? templateText.replace(/[\d.,]+/, amountText) : amountText;
        };

        const updatePriceTotal = (priceRoot, variant, quantity) => {
          const price = Number.parseInt(variant?.price, 10);
          if (!priceRoot || !Number.isFinite(price)) return false;

          const compareAtPrice = Number.parseInt(variant?.compare_at_price, 10) || 0;
          const hasCompareAtPrice = compareAtPrice > price;
          const saleTotal = price * quantity;
          const compareTotal = compareAtPrice * quantity;
          const priceNode = priceRoot.querySelector('.price');
          const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');
          const salePrice = priceRoot.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last');
          const comparePrice = priceRoot.querySelector('.price__sale .price-item--regular');

          priceNode?.classList.toggle('price--on-sale', hasCompareAtPrice);

          if (hasCompareAtPrice) {
            if (regularPrice) regularPrice.textContent = formatPriceAmount(saleTotal, regularPrice.textContent);
            if (salePrice) salePrice.textContent = formatPriceAmount(saleTotal, salePrice.textContent);
            if (comparePrice) comparePrice.textContent = formatPriceAmount(compareTotal, comparePrice.textContent);
          } else if (regularPrice) {
            regularPrice.textContent = formatPriceAmount(saleTotal, regularPrice.textContent);
          } else if (salePrice) {
            salePrice.textContent = formatPriceAmount(saleTotal, salePrice.textContent);
          }

          const saveBadge = priceRoot.querySelector('.Save');
          if (saveBadge) {
            saveBadge.setAttribute('data1', String(compareTotal || saleTotal));
            saveBadge.setAttribute('data2', String(saleTotal));
          }

          return true;
        };

        const syncPrice = () => {
          const originPrice = root.querySelector(selectors.originPrice);
          if (!originPrice) return;
          const selectedVariant = getSelectedVariant();
          const quantity = getQuantity();
          const sourcePriceHTML = originPrice.innerHTML;
          const selectedVariantId = String(
            selectedVariant?.id || root.querySelector(selectors.originVariant)?.value || ''
          );
          const quantityKey = String(quantity);

          root.querySelectorAll(selectors.bottomPrice).forEach((bottomPrice) => {
            const shouldRefreshSource =
              bottomPrice.dataset.quickAddSourcePrice !== sourcePriceHTML ||
              bottomPrice.dataset.quickAddVariantId !== selectedVariantId;
            const shouldRefreshQuantity = bottomPrice.dataset.quickAddPriceQuantity !== quantityKey;

            if (shouldRefreshSource) {
              bottomPrice.innerHTML = sourcePriceHTML;
              bottomPrice.dataset.quickAddSourcePrice = sourcePriceHTML;
              bottomPrice.dataset.quickAddVariantId = selectedVariantId;
            }

            if (shouldRefreshSource || shouldRefreshQuantity) {
              updatePriceTotal(bottomPrice, selectedVariant, quantity);
              bottomPrice.dataset.quickAddPriceQuantity = quantityKey;
            }
          });
        };

        const syncButtons = () => {
          copyButtonState(root.querySelector(selectors.originSubmit), root.querySelector(selectors.bottomSubmit));
        };

        const syncAll = () => {
          syncQuantity();
          syncVariant();
          syncPrice();
          syncButtons();
        };

        const scheduleSync = () => {
          if (syncFrame) window.cancelAnimationFrame(syncFrame);
          syncFrame = window.requestAnimationFrame(() => {
            syncFrame = null;
            syncAll();
          });
          window.setTimeout(syncAll, 250);
        };

        root.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;

          if (target.matches(`${selectors.originQuantity}, ${selectors.bottomQuantity}`)) {
            syncQuantity(target);
            return;
          }

          if (target.matches(`${selectors.originVariant}, ${selectors.bottomVariant}`) || target.closest('variant-selects')) {
            scheduleSync();
          }
        });

        root.addEventListener('input', (event) => {
          const target = event.target;
          if (target instanceof Element && target.matches(`${selectors.originQuantity}, ${selectors.bottomQuantity}`)) {
            syncQuantity(target);
          }
        });

        root.addEventListener('click', (event) => {
          const button = event.target.closest?.('quantity-input .quantity__button');
          if (!button) return;

          window.requestAnimationFrame(() => {
            const input = button.closest('quantity-input')?.querySelector('.quantity__input');
            if (input) syncQuantity(input);
          });
        });

        root.addEventListener('product-info:loaded', scheduleSync);

        new MutationObserver(scheduleSync).observe(root, {
          childList: true,
          subtree: true,
        });

        root.quickAddSyncPurchaseControls = scheduleSync;
        scheduleSync();
      }
    }
  );
}
